import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/core/services/snackbar/snackbar.service';
import { MatDialogResponse } from 'src/app/shared/models/constants/mat-dialog-response';
import { VipLevelSettings } from 'src/app/shared/models/constants/vip-level-settings';
import { UserService } from 'src/app/core/api/user/user.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';

@Component({
  selector: 'app-delete-vip-modal',
  templateUrl: './delete-vip-modal.component.html',
  styleUrls: ['./delete-vip-modal.component.scss'],
})
/**
 * Modal for deleting a business level.
 */
export class DeleteVipModalComponent {
  loading = false;
  labelToMark = {
    title: 'delete-vip-modal.mark.title',
    warning: 'delete-vip-modal.mark.warning',
    info: 'delete-vip-modal.mark.info',
    danger: 'delete-vip-modal.mark.danger',
    cancel: 'delete-vip-modal.cancel',
    action: 'delete-vip-modal.mark.action',
  };
  labelToUnmarck = {
    title: 'delete-vip-modal.unmark.title',
    warning: 'delete-vip-modal.unmark.warning',
    info: 'delete-vip-modal.unmark.info',
    danger: 'delete-vip-modal.unmark.danger',
    cancel: 'delete-vip-modal.cancel',
    action: 'delete-vip-modal.unmark.action',
  };
  labelToShow: any;
  toggleMessages = {
    success: 'delete-vip-modal.success-message',
    markedForDeletionSuccess:
      'delete-vip-modal.marked-for-deletion-success-message',
    unmarkedForDeletionSuccess:
      'delete-vip-modal.unmarked-for-deletion-success-message',
    error: 'delete-vip-modal.error-message',
  };

  /**
   * Constructor
   */
  constructor(
    private readonly dialogRef: MatDialogRef<DeleteVipModalComponent>,
    private readonly snackBarService: SnackBarService,
    @Inject(MAT_DIALOG_DATA) public data: VipLevelSettings,
    private readonly userService: UserService,
    private readonly translationService: TranslationService
  ) {
    this.dialogRef.disableClose = this.loading ?? false;
    this.translationService.translateObject(this.toggleMessages);
    this.labelToShow = this.data.markedForDeletion
      ? this.labelToUnmarck
      : this.labelToMark;
    this.translationService.translateObject(this.labelToShow);
  }

  /**
   * Action to close the dialog
   */
  onDialogClose() {
    this.dialogRef.close(MatDialogResponse.FAIL);
  }

  /**
   * Deletes business level by id
   */
  changeMarkToDeleteBusinessLevel() {
    this.loading = true;
    this.userService.markToDeleteBusinessVipLevel(this.data.id).subscribe({
      next: () => {
        this.dialogRef.close(MatDialogResponse.SUCCESS);
        if (this.data.markedForDeletion) {
          this.snackBarService.success(
            this.toggleMessages.unmarkedForDeletionSuccess
          );
        } else {
          this.snackBarService.success(
            this.toggleMessages.markedForDeletionSuccess
          );
        }
      },
      error: (response) => {
        this.dialogRef.close(MatDialogResponse.FAIL);
        const fullMessage = response.error.errorMessage;
        const parsedMessage = fullMessage.split(':').pop()?.trim();
        this.snackBarService.error(parsedMessage || this.toggleMessages.error);
      },
    });
  }
}
